import { Box, Button, Typography, Paper } from '@mui/material';
import { CameraAlt as CameraAltIcon, Close as CloseIcon } from '@mui/icons-material';
import { useFeedback } from '../../context/FeedbackContext';

export default function ScreenshotBanner() {
  const { isBannerVisible, captureScreenshot, hideBanner } = useFeedback();

  if (!isBannerVisible) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      }}
    >
      <Paper
        elevation={8}
        sx={{
          p: 4,
          maxWidth: 500,
          textAlign: 'center',
        }}
      >
        <CameraAltIcon sx={{ fontSize: 48, mb: 2, display: 'block', margin: '0 auto 16px' }} />
        <Typography variant="h6" gutterBottom>
          Ready to Capture Screenshot
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Click "Take Screenshot" to capture the current page, or cancel to go back.
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
          <Button variant="outlined" onClick={hideBanner} startIcon={<CloseIcon />}>
            Cancel
          </Button>
          <Button variant="contained" onClick={captureScreenshot} startIcon={<CameraAltIcon />}>
            Take Screenshot
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
